import { Avatar, Group, Text } from '@mantine/core';
import { IconAt, IconMoneybag } from '@sloyd/icons';
import { numeric } from 'shared-base';
import classes from './UserInfo.module.css';
import { Wrapper } from './UserInfo.style';

export type UserInfoProps = {
  user: IUser;
};

export function UserInfo(props: UserInfoProps) {
  const { user } = props;
  const { email, username, picture, planName, credits } = user;

  return (
    <Wrapper className='UserInfo-wrapper' data-testid='UserInfo-wrapper'>
      <Group wrap='nowrap'>
        <Avatar src={picture} size={94} radius='md' />
        <div>
          <Text fz='xs' tt='uppercase' fw={700} c='dimmed'>
            {planName} Plan
          </Text>

          <Text fz='lg' fw={500} className={classes.name}>
            {username}
          </Text>

          <Group wrap='nowrap' gap={10} mt={3}>
            <IconAt stroke={1.5} size={16} className={classes.icon} />
            <Text fz='xs' c='dimmed'>
              {email}
            </Text>
          </Group>

          <Group wrap='nowrap' gap={10} mt={5}>
            <IconMoneybag stroke={1.5} size={16} className={classes.icon} />
            <Text fz='xs' c='dimmed'>
              {numeric(credits)} API credits
            </Text>
          </Group>
        </div>
      </Group>
    </Wrapper>
  );
}

export default UserInfo;
